/** Shared offline-storage constants (used by the SW and the client). */

/** Passive LRU cache for browsed tiles (spec 04). Bump to drop every browsed
 *  tile (v2: blank ENC tiles cached while prod's ENC endpoint was refused). */
export const TILE_CACHE = 'tiles-v2';
export const TILE_LRU_MAX = 2000;
export const TILE_LRU_CHECK_EVERY = 50;

/** Explicit region download buckets are named `region-<uuid>`. */
export const REGION_CACHE_PREFIX = 'region-';

export function regionCacheName(id: string): string {
  return `${REGION_CACHE_PREFIX}${id}`;
}

/** Region download policy (spec 04). */
export const REGION_ZOOM_MIN = 8;
export const REGION_ZOOM_MAX = 15;
export const REGION_MAX_TILES = 15_000;
export const MAX_REGIONS = 3;

/** Tiles a region fetch tags itself with so the SW routes it to the bucket. */
export const REGION_HEADER = 'x-los-region';
